import React, { useEffect, useRef } from 'react';
import { ScrollView, Text, Pressable, View } from 'react-native';
import { useFavoriteSettingsContext } from '../../../runtime/Page/FavoriteSettings/FavoriteSettingsContext';

import defaultStyles from './NavigationPicker.jss';

type ScrollViewRef = ScrollView & {
    flashScrollIndicators: () => void;
};

interface IItem {
    value: string;
    title: string;
    postfix: string;
}

interface IProps {
    isDisplayed: boolean;
    items: IItem[];
    selectedItem: IItem;
    onSelect: (item: IItem) => void;
    isDisplayedInFavoritesSettings: boolean;
}

const NavigationPicker = ({
    isDisplayed,
    onSelect,
    items,
    selectedItem,
    isDisplayedInFavoritesSettings
}: IProps): JSX.Element | false => {
    const scrollViewRef = useRef<ScrollViewRef | null>(null);
    const { setNavigationPickerWidth } = useFavoriteSettingsContext() as any;

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;
        if (isDisplayed) {
            // show scrollIndicator when scrollView rendered
            timeout = setTimeout(() => {
                if (scrollViewRef.current) scrollViewRef.current.flashScrollIndicators();
            }, 500);
        }
        return () => clearTimeout(timeout);
    }, [isDisplayed]);

    const navigationPickerLayout = (event) => {
        setNavigationPickerWidth(event.nativeEvent.layout.width);
    };

    return (
        isDisplayed && (
            <View
                style={
                    isDisplayedInFavoritesSettings
                        ? (defaultStyles as any).pickerWindowFavSettings
                        : defaultStyles.pickerWindow
                }
                onLayout={navigationPickerLayout}
                pointerEvents="box-none"
            >
                <View style={defaultStyles.content}>
                    <ScrollView
                        ref={scrollViewRef}
                        indicatorStyle="black"
                        persistentScrollbar
                        nestedScrollEnabled
                    >
                        {items.map((item) => (
                            <Pressable
                                key={`data-${item.value}`}
                                style={[
                                    defaultStyles.line,
                                    item.value === selectedItem.value && defaultStyles.activeLine
                                ]}
                                onPress={() => {
                                    onSelect(item);
                                }}
                            >
                                <View style={defaultStyles.textContainer}>
                                    <Text
                                        style={[
                                            defaultStyles.lineText,
                                            item.value === selectedItem.value &&
                                            defaultStyles.lineTextActive
                                        ]}
                                        numberOfLines={1}
                                    >
                                        {item.title} {item?.postfix && item.postfix}
                                    </Text>
                                </View>
                            </Pressable>
                        ))}
                    </ScrollView>
                </View>
            </View>
        )
    );
};

export default NavigationPicker;
